import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

import CustomDialog from 'src/components/custom-dialog/custom-dialog';
import CustomTableCell from 'src/components/custom-table-cell/custom-table-cell';
import DataTable from 'src/components/data-table/data-table';
import Image from 'src/components/image';
import Page from 'src/components/page/page';

import Filter from './components/filter/filter';
import TableCollapse from './components/table-collapse/table-collapse';
import { usePromotions } from './promotions.hook';

function RowConfig({ row }: { row: any }) {
  const { promotionName, startDate, endDate, banner, preview } = row;
  const formattedDate = startDate && endDate ? `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}` : '';
  return (
    <>
      <CustomTableCell borderLeft>
        <Typography
          typography="body-md"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            maxWidth: 150,
            textAlign: 'center',
          }}
        >
          {promotionName}
        </Typography>
      </CustomTableCell>
      <CustomTableCell>
        <Typography typography="body-md">{formattedDate}</Typography>
      </CustomTableCell>
      <CustomTableCell>{banner ? <Image src={banner} width="134px" height="58px" /> : <Typography />}</CustomTableCell>

      <CustomTableCell>
        <Typography
          typography="body-md"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            maxWidth: 150,
            textAlign: 'center',
          }}
        >
          {preview}
        </Typography>
      </CustomTableCell>
    </>
  );
}

export default function Promotions() {
  const {
    isLoading,
    tableHeader,
    promotions,
    limit,
    order,
    orderBy,
    page,
    total,
    checked,
    useConfirmDeleteDialog,
    createSortHandler,
    handleChangePage,
    handleChangeRowsPerPage,
    handleCheckRow,
    handleDelete,
    handleConfirmDelete,
    handleAddNew,
    getData,
  } = usePromotions();
  return (
    <Page title="Promoções e Campanhas">
      <Typography typography="bold-hd-lg">Promoções e Campanhas</Typography>
      <Box height="32px" />
      <Filter title="Promoções e Campanhas Cadastrados" getData={getData} handleAddNew={handleAddNew} />
      <Box height="48px" />
      <DataTable
        collapseNewIdCondition="-"
        header={tableHeader}
        rows={promotions}
        collapseConfig={(row) => <TableCollapse row={row} getData={getData} />}
        rowConfig={(row) => <RowConfig row={row} />}
        createSortHandler={createSortHandler}
        handleDelete={handleDelete}
        order={order}
        orderBy={orderBy}
        count={total}
        isLoading={isLoading}
        checked={checked}
        page={page}
        rowsPerPage={limit}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        setChecked={handleCheckRow}
      />
      {useConfirmDeleteDialog.value && (
        <CustomDialog
          open={useConfirmDeleteDialog.value}
          icon="alert-line"
          title="Atenção"
          content="Deseja mesmo deletar a Promoção?"
          confirmText="Remover"
          cancelText="Cancelar"
          onConfirm={handleConfirmDelete}
          onClose={useConfirmDeleteDialog.onFalse}
        />
      )}
    </Page>
  );
}
